import { GameplayTier } from '__generated__/globalTypes';
import type { unitMapping } from 'lib/style';

import { Stars } from '../StarRank/Stars';

const convertTierToNumberOfStars = (gameplayTier: GameplayTier) => {
  return {
    [GameplayTier.GOAT]: 5,
    [GameplayTier.STAR]: 4,
    [GameplayTier.IMPACT]: 3,
    [GameplayTier.ROSTER]: 2,
    [GameplayTier.DNP]: 1,
  }[gameplayTier];
};

type GameplayTierStarsProps = {
  gameplayTier: GameplayTier;
  size?: keyof typeof unitMapping;
};

export const GameplayTierStars = ({
  gameplayTier,
  size = 1,
}: GameplayTierStarsProps) => {
  const nbStars = convertTierToNumberOfStars(gameplayTier);
  const sparkles = GameplayTier.GOAT === gameplayTier;

  return <Stars count={nbStars} size={size} sparkles={sparkles} />;
};
